/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { MarkIconType } from 'feature/YandexMap/types'
import { RootState } from 'store/types'

import { actions } from '../YandexMapSlice'

// двигать карту к координатам геолокации
export const goToCoordinates = createAsyncThunk<
  void,
  {
    position: GeolocationPosition
  },
  { state: RootState }
>(
  'yandexMap/successGetGeoFunction',
  async ({ position }, { getState, dispatch }) => {
    try {
      const YMap = window.map
      const zoom = getState().yandexMap.zoom
      if (!YMap) throw new Error('YMap instance is not available')
      const { latitude, longitude } = position.coords

      // двигаемся к точке
      YMap.panTo([latitude, longitude], { flying: true }).then(() => {
        // устанавливаем зум и центр карты
        YMap.setCenter([latitude, longitude], zoom, { duration: 300 }).then(
          () => {
            // ставим метку
            dispatch(actions.setGeolocationMarkCoords([latitude, longitude]))
            dispatch(actions.setGeolocationMarkIcon(MarkIconType.geolocation))
          },
        )
      })
    } catch (error) {
      console.error('moveMapToSavedCords ', error)
    }
  },
)
